const USStates = [
  {
    name: 'Alabama',
    abbreviation: 'AL',
    value: 73
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
    value: 74
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS',
    value: 75
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
    value: 76
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
    value: 77
  },
  {
    name: 'California',
    abbreviation: 'CA',
    value: 78
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
    value: 79
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
    value: 80
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
    value: 81
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
    value: 82
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM',
    value: 83
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
    value: 84
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
    value: 85
  },
  {
    name: 'Guam',
    abbreviation: 'GU',
    value: 86
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
    value: 87
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
    value: 88
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
    value: 89
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
    value: 90
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
    value: 91
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
    value: 92
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
    value: 93
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
    value: 94
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
    value: 95
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH',
    value: 96
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
    value: 97
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
    value: 98
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
    value: 99
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
    value: 100
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
    value: 101
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
    value: 102
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
    value: 103
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
    value: 104
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
    value: 105
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
    value: 106
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
    value: 107
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
    value: 108
  },
  {
    name: 'New York',
    abbreviation: 'NY',
    value: 109
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
    value: 110
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
    value: 111
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP',
    value: 112
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
    value: 113
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
    value: 114
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
    value: 115
  },
  {
    name: 'Palau',
    abbreviation: 'PW',
    value: 116
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
    value: 117
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
    value: 118
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
    value: 119
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
    value: 120
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
    value: 121
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
    value: 122
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
    value: 123
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
    value: 124
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
    value: 125
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI',
    value: 126
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
    value: 127
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
    value: 128
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
    value: 129
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
    value: 130
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
    value: 131
  }
];

export default USStates;



// WEBPACK FOOTER //
// ./app/constants/USStates.js